<!-- MODULE ORDERFORM START -->
<div class="module module-orderform" :class="{'module-orderform-opened': openForm}">
    <div @click="openForm = false" class="close-item">
        {{ $t('Close') }}
    </div>
    <button @click="setTab('buy')" :class="{'button-tab-buy-active': activeTab == 'buy'}" class="module-orderform__buy-forms__button button-tab button-tab-buy">
        <span>
            {{ $t(futures ? 'Buy/Long' : 'Buy') }}
        </span>
    </button>

    <button @click="setTab('sell')" :class="{'button-tab-sell-active': activeTab == 'sell'}"  class="module-orderform__buy-forms__button button-tab button-tab-sell">
        <span>
            {{ $t(futures ? 'Sell/Short' : 'Sell') }}
        </span>
    </button>

    <div class="button-clear"></div>

    <div class="module-container">
        <!-- module head start -->
        <div class="module-head">

            <div v-if="futures" class="futures-xs">
                <h4>Select Leverage</h4>
                <ul>
                    <li @click="setLeverage(1)" :class="{'active': leverage == 1}">1%</li>
                    <li @click="setLeverage(25)"  :class="{'active': leverage == 25}">25%</li>
                    <li @click="setLeverage(50)"  :class="{'active': leverage == 50}">50%</li>
                    <li @click="setLeverage(75)"  :class="{'active': leverage == 75}">75%</li>
                    <li @click="setLeverage(100)"  :class="{'active': leverage == 100}">100%</li>
                    <li @click="setLeverage(125)"  :class="{'active': leverage == 125}">125%</li>
                </ul>
            </div>

            <div class="module-orderform__title" :class="{'futures-tabs': futures}">
		<div v-if="!futures" @click="setOrderType('limit')" :class="{ 'module-orderform__active' : orderType == 'limit' }" class="module-orderform__title-item">{{ $t('Limit') }}</div>
		<div @click="setOrderType('market')" :class="{ 'module-orderform__active' : orderType == 'market' }" class="module-orderform__title-item">{{ $t('Market') }}</div>
                
        
                <div v-if="!futures" @click="setOrderType('stop_limit')" :class="{ 'module-orderform__active' : orderType == 'stop_limit' }" class="module-orderform__title-item">{{ $t('Stop-Limit') }}</div>
            </div>
        </div>
        <!-- module head end -->

        <!-- module body start -->
        <div class="module-body">

            <!-- module orderform container start -->
            <div class="module-orderform__container">

                <!-- module orderform buy start -->
                <div v-if="activeTab == 'buy'" class="module-orderform__buy">
                    <div class="module-orderform__buy-title">
                        <h3 v-if="!futures">{{ $t('Buy') }} {{ market.base_currency}}</h3>
                        <div class="module-orderform__buy-currency">
                            <span class="module-orderform__buy-icon">
                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect class="module-orderform__buy-color" x="2" y="4" width="20" height="16" rx="4"/>
                                    <line class="module-orderform__buy-color" x1="21.5" y1="9.5" x2="2.5" y2="9.5"/>
                                    <line class="module-orderform__buy-color" x1="19.5" y1="16.5" x2="16.5" y2="16.5"/>
                                </svg>
                            </span>
                            {{ quoteWallet ? quoteWallet.balance_in_wallet : '-' }} {{ market.quote_currency}}
                        </div>
                    </div>

                    <div class="module-orderform__buy-forms">

                        <div class="module-orderform__buy-forms__item" :class="{'form-disabled': orderType == 'market', 'module-orderform__buy-forms__invalid': buyErrorField == 'price'}">
                            <label class="module-orderform__buy-forms__item-left">{{ $t('Price') }}</label>
                            <input @keyup="(e) => clearInput(e, 'buy','price')" @keypress="(e) => handleInput(e, 'buy','price')" @paste.prevent @drop.prevent :placeholder="orderType == 'market' ? $t('Market'): ''" :disabled="orderType == 'market'" v-model="bid.price" type="text">
                            <label class="module-orderform__buy-forms__item-right">{{ market.quote_currency}}</label>
                        </div>

                        <div v-if="!futures" class="module-orderform__buy-forms__item" :class="{'module-orderform__buy-forms__invalid': buyErrorField == 'quantity'}">
                            <label class="module-orderform__buy-forms__item-left"> {{ orderType == 'market' ? 'Quantity' : 'Amount'}}</label>
                            <input @keyup="(e) => clearInput(e, 'buy','quantity')" @keypress="(e) => handleInput(e, 'buy','quantity')" @paste.prevent @drop.prevent v-model="bid.quantity" type="text">
                            <label class="module-orderform__buy-forms__item-right">{{ orderType == 'market' ? market.quote_currency : market.base_currency}}</label>
                        </div>

                        <div v-if="futures" class="module-orderform__buy-forms__item" :class="{'module-orderform__buy-forms__invalid': buyErrorField == 'quantity'}">
                            <label class="module-orderform__buy-forms__item-left"> {{ 'Size' }}</label>
                            <input @keyup="(e) => clearInput(e, 'buy','quantity')" @keypress="(e) => handleInput(e, 'buy','quantity')" @paste.prevent @drop.prevent v-model="bid.quantity" type="text">
                            <label class="module-orderform__buy-forms__item-right">{{ market.quote_currency}}</label>
                        </div>

                        <div v-if="orderType == 'stop_limit'" class="module-orderform__buy-forms__item" :class="{'module-orderform__buy-forms__invalid': buyErrorField == 'trigger_price'}">
                            <label class="module-orderform__buy-forms__item-left">{{ $t('Stop') }}</label>
                            <input @keyup="(e) => clearInput(e, 'buy','trigger_price')" @keypress="(e) => handleInput(e, 'buy','trigger_price')" @paste.prevent @drop.prevent v-model="bid.trigger_price" type="text">
                            <label class="module-orderform__buy-forms__item-right">{{ market.quote_currency}}</label>
                        </div>

                        <div v-if="orderType != 'market'" class="module-orderform__buy-forms__item">
                            <label class="module-orderform__buy-forms__item-left">{{ $t('Total') }}</label>
                            <input @keyup="(e) => clearInput(e, 'buy','total')" @keypress="(e) => handleInput(e, 'buy','total')" @paste.prevent @drop.prevent type="text" readonly v-model="bid.total">
                            <label class="module-orderform__buy-forms__item-right">{{ market.quote_currency}}</label>
                        </div>
                        <vue-slider @change="changeBuySlider" v-model="buySlider.value" :disabled="buySlider.disabled" :tooltip-formatter="buySlider.formatter" :marks="buySlider.marks" :adsorb="true" :included="true" :hide-label="true" :tooltip-placement="'top'"></vue-slider>

                        <button @click="placeBuyOrder()" :class="{ 'opacity-75': placingBuyOrder }" class="module-orderform__buy-forms__button">
                            <span>
                                <svg v-show="placingBuyOrder" class="inline animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                {{ $t('Buy') }}
                                <template v-if="!futures">{{ market.base_currency}}</template>
                            </span>
                        </button>
                    </div>

                </div>
                <!-- module orderform buy end -->

                <!-- module orderform sell start -->
                <div v-if="activeTab == 'sell'" class="module-orderform__sell">
                    <div class="module-orderform__sell-title">
                        <h3 v-if="!futures">{{ $t('Sell') }} {{ market.base_currency}}</h3>
                        <div class="module-orderform__sell-currency">
                            <span class="module-orderform__sell-icon">
                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect class="module-orderform__sell-color" x="2" y="4" width="20" height="16" rx="4"/>
                                    <line class="module-orderform__sell-color" x1="21.5" y1="9.5" x2="2.5" y2="9.5"/>
                                    <line class="module-orderform__sell-color" x1="19.5" y1="16.5" x2="16.5" y2="16.5"/>
                                </svg>
                            </span>
                            <template v-if="futures">
                                {{ quoteWallet ? quoteWallet.balance_in_wallet : '-' }} {{ market.quote_currency}}
                            </template>
                            <template v-if="!futures">
                                {{ baseWallet ? baseWallet.balance_in_wallet : '-' }} {{ market.base_currency}}
                            </template>
                        </div>
                    </div>

                    <div class="module-orderform__sell-forms">
                        <div class="module-orderform__sell-forms__item" :class="{'form-disabled': orderType == 'market', 'module-orderform__sell-forms__invalid': sellErrorField == 'price'}">
                            <label class="module-orderform__sell-forms__item-left">{{ $t('Price') }}</label>
                            <input @keyup="(e) => clearInput(e, 'ask','price')" @keypress="(e) => handleInput(e, 'ask','price')" @paste.prevent @drop.prevent :placeholder="orderType == 'market' ? $t('Market'): ''" :disabled="orderType == 'market'" v-model="ask.price" type="text">
                            <label class="module-orderform__sell-forms__item-right">{{ market.quote_currency}}</label>
                        </div>

                        <div v-if="!futures" class="module-orderform__sell-forms__item" :class="{'module-orderform__sell-forms__invalid': sellErrorField == 'quantity'}">
                            <label class="module-orderform__sell-forms__item-left">{{ $t('Amount') }}</label>
                            <input @keyup="(e) => clearInput(e, 'ask','quantity')" @keypress="(e) => handleInput(e, 'ask','quantity')" @paste.prevent @drop.prevent type="text" v-model="ask.quantity">
                            <label class="module-orderform__sell-forms__item-right">{{ futures ? market.quote_currency : market.base_currency}}</label>
                        </div>

                        <div v-if="futures" class="module-orderform__sell-forms__item" :class="{'module-orderform__sell-forms__invalid': sellErrorField == 'quantity'}">
                            <label class="module-orderform__sell-forms__item-left">{{ $t('Size') }}</label>
                            <input @keyup="(e) => clearInput(e, 'ask','quantity')" @keypress="(e) => handleInput(e, 'ask','quantity')" @paste.prevent @drop.prevent type="text" v-model="ask.quantity">
                            <label class="module-orderform__sell-forms__item-right">{{ market.quote_currency}}</label>
                        </div>

                        <div v-if="orderType == 'stop_limit'" class="module-orderform__sell-forms__item" :class="{'module-orderform__sell-forms__invalid': sellErrorField == 'trigger_price'}">
                            <label class="module-orderform__sell-forms__item-left">{{ $t('Stop') }}</label>
                            <input @keyup="(e) => clearInput(e, 'ask','trigger_price')" @keypress="(e) => handleInput(e, 'ask','trigger_price')" @paste.prevent @drop.prevent type="text" v-model="ask.trigger_price">
                            <label class="module-orderform__sell-forms__item-right">{{ market.quote_currency}}</label>
                        </div>

                        <div v-if="orderType != 'market'" class="module-orderform__buy-forms__item">
                            <label class="module-orderform__buy-forms__item-left">{{ $t('Total') }}</label>
                            <input @keyup="(e) => clearInput(e, 'ask','total')" @keypress="(e) => handleInput(e, 'ask','total')" @paste.prevent @drop.prevent type="text" readonly v-model="ask.total">
                            <label class="module-orderform__buy-forms__item-right">{{ market.quote_currency}}</label>
                        </div>
                        <vue-slider @change="changeSellSlider" v-model="sellSlider.value" :disabled="sellSlider.disabled" :tooltip-formatter="sellSlider.formatter" :marks="sellSlider.marks" :adsorb="true" :included="true" :hide-label="true" :tooltip-placement="'top'"></vue-slider>

                        <button @click="placeSellOrder()" :class="{ 'opacity-75': placingSellOrder }" class="module-orderform__sell-forms__button">
                            <span>
                                <svg v-show="placingSellOrder" class="inline animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                {{ $t('Sell') }}
                                <template v-if="!futures">{{ market.base_currency}}</template>
                            </span>
                        </button>

                    </div>
                </div>
                <!-- module orderform sell end -->

            </div>
            <div v-if="errors" class="mt-5 text-sm text-red-500">
                {{ errors }}
            </div>
            <!-- module orderform container end -->



        </div>
        <!-- module body end -->
    </div>
</div>
<!-- MODULE ORDERFORM END -->
